import { Divider } from 'antd';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import CardMaterial from '../CardMaterial/CardMaterial';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAlumDoorTextures } from '../../../../store/actions/texture.action';
import InfiniteScroll from 'react-infinite-scroll-component';
import { DesignerPageContext } from '../../DesignerPage';
import { useTranslation } from 'react-i18next';
import { InsideType } from '../../../../constants/enum';
import SearchComponent from '../../../../components/common/SearchComponent/SearchComponent';
import { openMessageError } from '../../../../components/common/Message/openMessageError';

const RightPaletteAlumDoorMenu = ({ open, onClose, title }) => {
  return (
    <>
      <RightMenuDesign
        open={open}
        classNames={{ root: 'top-84', content: 'flex flex-col !p-0 gap-0' }}
        header={
          <div className="flex self-stretch items-center justify-start gap-8">
            <ButtonIconGhostMedium
              icon={<Icon.ICArrowBack />}
              onClick={onClose}
            />
            <span className="text-title-large">{title}</span>
          </div>
        }
        content={(() => {
          try {
            return open ? <RenderContent /> : null;
          } catch (error) {
            console.log(error);
            return <></>;
          }
        })()}
      />
    </>
  );
};

export default RightPaletteAlumDoorMenu;

const RenderContent = () => {
  const { t } = useTranslation();
  const { selectedModels, selectedModel, sceneManager } =
    useContext(DesignerPageContext);
  const [texture, setTexture] = useState();
  const [search, setSearch] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState('');

  const dispatch = useDispatch();
  const { alumDoorTextures } = useSelector(state => state.texture);

  const traverseColorAndTexture = useCallback(
    selectedModel => {
      const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      if (modules && selectedModel) {
        const moduleEntries = Array.from(modules?.entries());
        const module = moduleEntries?.find(
          ([item, value]) => value.group.uuid === selectedModel?.uuid
        );

        if (module) {
          const [item, value] = module;

          const textureDoor = value?.textures.get('DOOR');

          if (textureDoor?.textureId) {
            setTexture({
              materialType: textureDoor.supplier?.name ?? '--',
              name: textureDoor.textureCode ?? t('Not selected'),
              src: textureDoor.textureUrl ?? '--',
              textureId: textureDoor.textureId,
              no_grain: textureDoor.no_grain,
              // special: specialTexture
            });
          } else {
            setTexture();
          }
        }
      }
    },
    [selectedModel, sceneManager]
  );

  const handleClick = useCallback(
    async (item, func, applyToAll) => {
      if (item.image) {
        const textureController = sceneManager.textureController;
        const applyTexture = async ({
          module,
          texture = {
            textureId: item.id,
            textureCode: item.name,
            material: 'Aluminum',
            texturePrice: item.price,
            url: item.image,
          },
          // excludeMeshes = [],
          // includeMeshTypes = [InsideType.DOOR],
        }) => {
          return await textureController.changeTextureAlumDoor({
            module,
            textureType: 'map',
            texture,
            // excludeMeshes,
            // includeMeshTypes,
          });
        };

        const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
        const moduleEntries = Array.from(modules?.entries());
        if (applyToAll && selectedModel) {
          const len = moduleEntries?.length;
          if (len) {
            for (let i = 0; i < len; i++) {
              const [key, value] = moduleEntries[i];
              let materialType = null;
              const model = value.group;

              if (
                ['lower', 'upper', 'ceiling'].some(
                  item =>
                    model?.userData?.moduleType?.includes(item) &&
                    selectedModel?.userData?.moduleType?.includes(item)
                )
              ) {
                await applyTexture({
                  module: value,
                });
              }
            }
          }
        } else {
          const len = selectedModels.length;
          if (len) {
            for (let i = 0; i < len; i++) {
              const model = selectedModels[i];
              const [item, value] = moduleEntries.find(
                ([item, value]) => value.group.uuid === model.uuid
              );
              await applyTexture({ module: value });
            }
          }
        }

        await sceneManager.calculateTotalCost?.({});
        func();
        traverseColorAndTexture(selectedModel);
      }
    },
    [sceneManager, selectedModel, selectedModels]
  );

  const loadMoreData = useCallback(async () => {
    const {
      preParams: { offset, limit },
    } = alumDoorTextures;
    try {
      dispatch(
        fetchAlumDoorTextures({
          offset: offset + limit,
          limit,
          code: debouncedSearch,
        })
      ).then(action => {
        // setLoading(false);
      });
    } catch (e) {
      openMessageError({ content: 'Failed to load texture data.' });
      // setLoading(false);
    }
  }, [debouncedSearch, alumDoorTextures]);

  // Debounce searchTerm
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // Đợi 500ms sau khi user ngừng gõ

    // Cleanup: Clear timer nếu user gõ tiếp
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    // loadMoreData();
    dispatch(
      fetchAlumDoorTextures({
        offset: 0,
        limit: 20,
        code:
          debouncedSearch?.trim() === '' ? undefined : debouncedSearch?.trim(),
      })
    );
  }, [debouncedSearch]);

  useEffect(() => {
    if (selectedModel) {
      traverseColorAndTexture(selectedModel);
    }
  }, [selectedModel]);

  return (
    <>
      {/* <div
        key={1}
        className="flex p-16 flex-col items-start gap-8 self-stretch bg-fills-white"
      >
        <div className="flex justify-between items-center self-stretch">
          <SearchComponent
            size="small"
            style={{ width: '100%' }}
            value={search}
            setValue={setSearch}
          />
        </div>
      </div>
      <Divider type="horizontal" className="m-0 !p-0" /> */}
      <div
        key={4}
        className="flex flex-col p-8 items-start gap-16 grow self-stretch overflow-auto"
        style={{ backgroundColor: '#F7F7F7' }}
      >
        <div
          id="right-palete-door-menu"
          className="flex flex-col self-stretch grow overflow-scroll"
        >
          <InfiniteScroll
            dataLength={alumDoorTextures.data.length}
            next={loadMoreData}
            hasMore={alumDoorTextures.data.length < alumDoorTextures.total}
            scrollableTarget={'right-palete-menu'}
            className="flex flex-row flex-wrap gap-2"
          >
            {alumDoorTextures.data.map((item, index) => {
              return (
                <CardMaterial
                  key={item.id}
                  item={{
                    title: item.name,
                    description: item.description,
                    src: item.icon,
                    detailLink: item.detail_link,
                  }}
                  active={texture && item.id === texture.textureId}
                  onClick={async (func, applyToAll) =>
                    await handleClick(item, func, applyToAll)
                  }
                />
              );
            })}
          </InfiniteScroll>
        </div>
      </div>
    </>
  );
};
